import { useEffect } from "react";
import { useDispatch } from "react-redux";
import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import connectedAuthWrapper from "redux-auth-wrapper/connectedAuthWrapper";

import SuspenseFallbackComponent from "./components/SuspenseFallbackComponent";
import Actions from "../login/duck/actions";
import { useLocation } from "react-router";

const locationHelper = locationHelperBuilder({});

function ActivateLoginModal() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(
      Actions.showLoginModal(true, {
        redirectTo: `${location.pathname + location.search}`,
      })
    );

    return () => {
      dispatch(Actions.showLoginModal(false));
    };
  }, [dispatch]);

  return null;
}

const userIsAuthenticatedDefaults = {
  authenticatedSelector: (state) => state.user.isAuthenticated !== false,
  authenticatingSelector: (state) => state.user.isAuthenticating,
  wrapperDisplayName: "UserIsAuthenticated",
  FailureComponent: () => <ActivateLoginModal />,
};

export const userIsAuthenticated = connectedAuthWrapper(
  userIsAuthenticatedDefaults
);

export const userIsAuthenticatedRedir = connectedRouterRedirect({
  ...userIsAuthenticatedDefaults,
  AuthenticatingComponent: SuspenseFallbackComponent,
  redirectPath: (state) => {
    if (state.user.shouldRetry) {
      return `/login/${state.user.provider}?retry=1`;
    } else {
      return `/login/${state.user.provider}`;
    }
  },
});

const userIsNotAuthenticatedDefaults = {
  // Want to redirect the user when they are done loading and authenticated
  authenticatedSelector: (state) => state.user.isAuthenticated === false,
  wrapperDisplayName: "UserIsNotAuthenticated",
};

export const userIsNotAuthenticated = connectedAuthWrapper(
  userIsNotAuthenticatedDefaults
);

export const userIsNotAuthenticatedRedir = connectedRouterRedirect({
  ...userIsNotAuthenticatedDefaults,
  redirectPath: (state, ownProps) => {
    return locationHelper.getRedirectQueryParam(ownProps) || "/";
  },
  allowRedirectBack: false,
});
